'use strict';

var $ = require('../internals/export');

var createHTML = require('../internals/create-html');

var forcedStringHTMLMethod = require('../internals/forced-string-html-method'); // `String.prototype.bold` method
// https://tc39.github.io/ecma262/#sec-string.prototype.bold


$({
  target: 'String',
  proto: true,
  forced: forcedStringHTMLMethod('bold')
}, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});